module.exports = __webpack_public_path__ + "static/media/levelOn03.2203412b.svg";